<template>
  <router-link
    :to="linkTo"
    :class="{ link: type === 'xs' }"
    class="text-sm-center"
    tag="div"
  >
    <div :class="`preview-theme-${type}`">
      <div
        :class="{
          'preview-wrap': !['xs'].includes(this.$vuetify.breakpoint.name)
        }"
      >
        <div
          class="preview-window"
          :class="{
            'layout fill-height': ['xs'].includes(this.$vuetify.breakpoint.name)
          }"
        >
          <img
            class="img-fluid align-self-center"
            :src="`${item.params.preview[page]}`"
          />
        </div>
      </div>
    </div>
    <button
      v-if="type === 'sm' && item.params.preview[`${page}xl`]"
      @click="
        $emit('openDialog', {
          type: 'img',
          src: item.params.preview[`${page}xl`]
        })
      "
    >
      <icon-fullscreen :color="$vuetify.theme.primary"></icon-fullscreen>
      <span class="subtitle-1 ml-2 line-height-1">
        Посмотреть экранную версию
      </span>
    </button>
  </router-link>
</template>
<script>
import IconFullscreen from "../icon/IconFullScreen.vue";

export default {
  name: "ThemePreview",

  components: { IconFullscreen },

  props: {
    themeId: {
      type: Number
    },
    type: {
      type: String,
      default: "xs"
    },
    page: {
      type: String,
      default: "login"
    }
  },

  data: () => ({}),

  mounted() {},

  computed: {
    item() {
      let item = this.$store.getters.themeDefaultParams;
      if (this.themeId && this.$store.getters.themeIsLoaded) {
        item = this.$store.getters.getTheme(this.themeId);
      }
      return item;
    },
    // ссылка для перехода по нажатию на картинку телефона на редактирование/создание темы
    linkTo() {
      let linkTo =
        this.type !== "xs"
          ? { name: "", params: {} }
          : this.themeId
          ? { name: "themeSettings", params: { id: this.themeId } }
          : { name: "themeCreate", params: {} };
      return linkTo;
    }
  },

  methods: {}
};
</script>
